export default __webpack_public_path__ + "static/18587-a1c764d0ddf5cec6cfbeef6f79744ba9.webp";